/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-records': {
    width: 15,
    height: 14,
    viewBox: '0 0 15 14',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M7.455.854a.35.35 0 0 1 .313 0l5.833 2.917a.35.35 0 0 1 0 .626L7.768 7.313a.35.35 0 0 1-.313 0L1.622 4.397a.35.35 0 0 1 0-.626L7.455.854zm-4.894 3.23l5.05 2.525 5.051-2.525-5.05-2.526L2.56 4.084zM1.465 9.76a.35.35 0 0 1 .47-.157l5.676 2.839 5.677-2.839a.35.35 0 1 1 .313.627l-5.833 2.916a.35.35 0 0 1-.313 0L1.62 10.23a.35.35 0 0 1-.156-.469z" _fill="#234357"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M1.465 6.843a.35.35 0 0 1 .47-.156L7.61 9.525l5.677-2.838a.35.35 0 1 1 .313.626L7.768 10.23a.35.35 0 0 1-.313 0L1.62 7.313a.35.35 0 0 1-.156-.47z" _fill="#234357"/>'
  }
})
